// extracted by mini-css-extract-plugin
export var container = "_fd-0";
export var content = "_fd-3";
export var customerTitle = "_fd-4";
export var empty = "_fd-5";
export var gray = "_fd-6";
export var header = "_fd-7";
export var info = "_fd-8";
export var loading = "_fd-2";
export var loadingCard = "_fd-9";
export var oneLine = "_fd-a";
export var personName = "_fd-e";
export var pillContainer = "_fd-b";
export var selected = "_fd-1";
export var text = "_fd-c";
export var twoLines = "_fd-d";
export var unread = "_fd-f";
export var unreadIndicator = "_fd-g";